<template>
  <div class="back-top">
    <div class="container" :style="`left: -${pagePadding}px; width: calc(100% + ${pagePadding * 2}px);`">
      <div class="back-btn pointer" @click="goBack">
        <i class="iconsimple icon-s-changguijiantou-zuo"></i>
        <span>{{ $t('返回') }}</span>
      </div>
      <el-divider v-if="title" direction="vertical" />
      <div class="title">{{ title }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BackTop',
  props: {
    title: {
      type: String,
      default: ''
    },
    pagePadding: {
      type: Number,
      default: 0
    },
    selfGoBack: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    goBack() {
      if (this.selfGoBack) {
        this.$emit('goBack');
        return;
      }
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
  .back-top {
    width: 100%;
    padding: 24px;
    position: relative;
    .container {
      position: absolute;
      top: 0px;
      display: flex;
      padding: 12px 20px;
      align-items: center;
      border-bottom: 1px solid #E5E6EB;
    }
    .back-btn {
      display: flex;
      align-items: center;
      i {
        font-size: 20px;
        margin-right: 3px;
      }
    }

    ::v-deep .el-divider {
      height: 10px;
      margin: 0 24px;
    }

    .title {
      font-size: 16px;
      font-weight: 600;
    }
  }
</style>
